// CS-2018 - EC2 server-control dashboard (Super Admin)
// All calls skip the global error popup — failures are surfaced by the dashboard
// itself (toast / banner) so the user never gets two alerts for one failure.
import { http } from "./http";
import { EC2_AUDIT_LOGS_URL, EC2_LIST_URL, EC2_START_URL, EC2_STOP_URL } from "./URL";

export type Ec2ActionRequest = {
    instanceId?: string;
    name?: string;
};

const SKIP_ERROR_POPUP = { skipErrorPopup: true };

// silent = background poll: x-skip-loader keeps the global loading dialog closed
export const getEc2Instances = async (silent = false) => {
    try {
        const response = await http.get(
            EC2_LIST_URL,
            silent ? { headers: { "x-skip-loader": "true" } } : undefined,
            SKIP_ERROR_POPUP,
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const startEc2Instance = async (request: Ec2ActionRequest) => {
    try {
        const response = await http.post(EC2_START_URL, request, undefined, SKIP_ERROR_POPUP);
        return response;
    } catch (error) {
        throw error;
    }
};

export const stopEc2Instance = async (request: Ec2ActionRequest) => {
    try {
        const response = await http.post(EC2_STOP_URL, request, undefined, SKIP_ERROR_POPUP);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getEc2AuditLogsForInstance = async (request: Ec2ActionRequest) => {
    try {
        const response = await http.get(
            EC2_AUDIT_LOGS_URL,
            { params: { instanceId: request.instanceId, name: request.name } },
            SKIP_ERROR_POPUP,
        );
        return response;
    } catch (error) {
        throw error;
    }
};
